export const HELP_NAV_LINK = {destination: 'help', label: 'Help'};
